<template>
  <div class="row justify-center">
    <short-transfer-form
      ref="shortForm"
      class="short-form col-12 col-sm-8 col-md-6"
      in-iframe
      @submit="submit"
    />
  </div>
</template>

<script>
import ShortTransferForm from 'components/ShortTransferForm';

const module = {
  namespaced: true,
  state: () => ({
    widget: null,
  }),
  actions: {
    setWidget({ commit }, widget) {
      commit('setWidget', widget);
    },
  },
  mutations: {
    setWidget(state, widget) {
      state.widget = widget;
    },
  },
};

export default {
  name: 'Widget',
  components: {
    ShortTransferForm,
  },
  preFetch({ store, ssrContext }) {
    store.registerModule('widget', module);
    return store.dispatch('widget/setWidget', ssrContext.req.widget);
  },
  computed: {
    widget() {
      return this.$store.state.widget.widget;
    },
  },
  created() {
    if (!this.$store.getters.account && this.widget) {
      const { locale, currency } = this.widget;
      this.$q.localStorage.set('account_settings', { currency, locale });
    }
  },
  async mounted() {
    const resizeObserver = new ResizeObserver(() => {
      this.postMessage({
        height: this.$refs.shortForm.$el.offsetHeight,
      });
    });
    resizeObserver.observe(this.$refs.shortForm.$el);
  },
  methods: {
    postMessage(message) {
      window.parent.postMessage({
        ...message,
        source: 'gettransfer',
      }, '*');
    },
    submit(params) {
      const location = `${this.$store.getters.configs.base_url}${
        this.$router.resolve({
          ...params,
          query: {
            ...params.query,
            ...(this.widget && this.widget.transfer_utm),
          },
        }, this.$route).href
      }`;

      this.postMessage({ location });
    },
  },
};
</script>
